import { cnva } from '@/app/utils/cnva';

export const ToastStyled = cnva(
  [
    'center-x fixed top-14 z-50',
    'rounded-2xs mx-auto flex w-full max-w-82 items-center gap-4 px-4 py-2 shadow-md md:max-w-144',
    'before:rounded-l-2xs before:absolute before:inset-0 before:w-1',
  ],
  {
    variants: {
      theme: {
        light: 'bg-white',
        dark: 'bg-gray-900 text-white',
      },
      type: {
        info: 'before:bg-blue-400',
        success: 'before:bg-green-500',
        error: 'before:bg-red-500',
      },
    },
    defaultVariants: {
      theme: 'light',
      type: 'info',
    },
  }
);
